import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { selectors as userSelectors } from 'ducks/user';
import SubHeader from 'components/general/SubHeader/SubHeader';

const getArticlesQuery = createSelector(
  userSelectors.preferences,
  R.prop('dashboardArticles'),
);

const UserArticlesSubHeader = connect(state => ({
  title: 'Your latest articles',
  action: {
    title: 'View all articles',
    icon: 'bell',
    to: {
      type: 'ARTICLES_INDEX',
      query: getArticlesQuery(state),
    },
  },
}))(SubHeader);

export default UserArticlesSubHeader;
